module.exports = __webpack_public_path__ + "img/image (11).36d375e5.png";